import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ThemeModel } from "../../models/api/theme.model";
import { AppConfigService } from "../app-config.service";

@Injectable({
  providedIn: 'root'
})
export class ApiThemeService {

  private readonly apiUrl: string;
  private readonly baseUrl = '/api/LevanteTheme/';

  constructor(private readonly appConfigService: AppConfigService,
    private readonly httpClient: HttpClient) {
    this.apiUrl = this.appConfigService.getConfig().apiUrl;
  }

  public getTheme(sourceKey: string): Observable<ThemeModel> {
    const url = `${this.apiUrl}${this.baseUrl}GetTheme/${sourceKey}?t=${Date.now()}`;

    return this.httpClient.get<ThemeModel>(url, {
      transferCache: false
    });
  }
}
